'use strict';

/**
 *
 * @name: apiCategoryService
 *
 */

function ApiContactRequestService(
  $rootScope,
  APP_CONSTANTS,
  $http
) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function send(data) {

    var target = $rootScope.apiUrlBak + '/contact-request';

    return $http.post(target, data);
  }

  /**
   *
   * @PRIVATE
   *
   */

  return {
    send: send
  };
}

export default ApiContactRequestService;



// WEBPACK FOOTER //
// ./app/components/_api/contact-request.service.js